<script lang="ts">
    import type {Datatype} from 'src/typings';
    import KpDatatypedList from './KpDatatypedList.svelte';
    import KpDatatypedScalar from './KpDatatypedScalar.svelte';

    export let datatype: Datatype;
    export let value;
    export let fallback = '';
</script>


<span>
    {#if datatype.nestedDatatype}
        <KpDatatypedList {value} datatype={datatype.nestedDatatype} {fallback}/>
    {:else}
        <KpDatatypedScalar {value} {datatype} {fallback}/>
    {/if}
</span>